module.exports = require('querystring-es3/');
